// time是停留时间
function closeMes(time) {
  let endID = setTimeout(function () { })
  for (let i = 0; i < endID; i++) {
    clearTimeout(i)
    clearInterval(i)
  }
  let endID1 = setTimeout(function () { })
  setTimeout(() => { this.mes.close() }, time)
}
export default closeMes